import { render, staticRenderFns } from "./LeadBoardDealHeader.vue?vue&type=template&id=e19ab5da&"
import script from "./LeadBoardDealHeader.vue?vue&type=script&lang=js&"
export * from "./LeadBoardDealHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports